// Polyfill process for older react-scripts / dependencies
if (typeof window !== 'undefined' && !window.process) {
    window.process = { env: { NODE_ENV: 'development' } };
}
